import { all, takeEvery, put, call } from "redux-saga/effects";

import actions from "./actions";
import { axiosPrivate } from "../../Helpers/axios";


// Get total billers
function* getTotalBillersResponse() {
  try {
    const response = yield call(axiosPrivate, `/billers/totalBiller`);
    yield put(actions.getTotalBillersSuccess(response?.data));
  } catch (error) {
    yield put(
      actions.getTotalBillersFailed(
        error.response?.data?.message ? error.response.data.message : error.message
      )
    );
  }
}

// get all categories
function* getCategoriesResponse() {
  try {
    const response = yield call(axiosPrivate, `/billers/getAllCategory`);
    yield put(actions.getCategoriesSuccess(response?.data?.data || []));
  } catch (error) {
    yield put(
      actions.getCategoriesFailed(
        error.response?.data?.message || error.message
      )
    );
  }
}

// Unified search saga
function* searchBillersResponse({
  payload: { billerId, category, channel, page = 1, limit = 10 },
}) {
  try {
    const params = new URLSearchParams();
    if (billerId) params.append("billerId", billerId);
    if (category) params.append("category", category);
    if (channel) params.append("channel", channel);
    params.append("page", page);
    params.append("limit", limit);

    const response = yield call(
      axiosPrivate,
      `/billers/search?${params.toString()}`
    );

    yield put(actions.searchBillersSuccess(response?.data));
  } catch (error) {
    yield put(
      actions.searchBillersFailed(
        error.response?.data?.message ? error.response.data.message : error.message
      )
    );
  }
}

export default function* billerSaga() {
  yield all([takeEvery(actions.GET_TOTAL_BILLERS, getTotalBillersResponse)]);
  yield all([takeEvery(actions.SEARCH_BILLERS, searchBillersResponse)]);
  yield all([takeEvery(actions.GET_CATEGORIES, getCategoriesResponse)]);
  
}
